import req from '../req'
// 导购管理

// 获取导购员列表
export function getSalesmanList (params) {
  return req.get('/salesperson/salesperson', params)
}

// 绑定导购员门店信息
export function updateStore (params) {
  return req.post('/salesperson/save-bind-store', params)
}

// 获取导购已经绑定的店铺列表
export function getBindStoreList (salespersonId, params) {
  return req.get('/salesperson/get-bind-store/' + salespersonId, params)
}

// 获取导购未绑定的店铺列表
export function getNotBindStoreList (params) {
  return req.get('/salesperson/storelist', params)
}

// 冻结/解冻 导购员
export function updateFreeze (params) {
  return req.post('/salesperson/salesperson/batch-update-status', params)
}

// 获取单个的导购码
export function getSalesersonCode (salespersonId, params) {
  return req.post('/salesperson/saleserson-code/' + salespersonId, params)
}

// 导购二维码导出-店铺查询以及编号区间接口
export function getCodeList (params) {
  return req.get('/salesperson/code-list', params)
}

// 导购二维码导出
export function exportCode (params) {
  return req.post('/salesperson/export-code', params)
}

//同步失败重试
export function syncRetry (params) {
  return req.post('/salesperson/salesperson/sync-retry', params)
}

//导购删除
export function salespersonDel (salespersonId) {
  return req.post('/salesperson/salesperson/delete/' + salespersonId)
}
